export const __DEV__ = false as boolean;
